module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"sunrise-sunset\"-in-pomona-california-1903cd1910c98ab926551ae60a0001f2.png";